// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu{width:30%;display:flex;flex-direction:row;justify-content:space-between;height:30px;line-height:30px;margin-bottom:30px;font-size:14px}", ""]);
// Exports
module.exports = exports;
